import { jsxs as a, jsx as l } from "react/jsx-runtime";
const n = (e) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 24 25", ...e, children: [
  /* @__PURE__ */ l("path", { fill: "#212134", d: "M6.24 11.28H18v1.44H6.24v-1.44Z" }),
  /* @__PURE__ */ l(
    "path",
    {
      fill: "#212134",
      d: "m5.871 10.699 8.347-6.176.86 1.162-8.347 6.177-.86-1.163ZM5.899 13.354l8.346 6.176.864-1.167-8.347-6.176-.863 1.167Z"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      fill: "#212134",
      fillRule: "evenodd",
      d: "M3.6 14.399a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Zm0 1.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2ZM20.4 14.399a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Zm0 1.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2ZM16.8 22.8a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Zm0 1.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2ZM16.8 6a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Zm0 1.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Z",
      clipRule: "evenodd"
    }
  )
] }), t = n;
export {
  t as default
};
